import ReturnedByDefaultValue from "./returned-by-default-value";

export default class ContinuedByDefaultValue extends ReturnedByDefaultValue {
    constructor(play, fragment, summaryContext) {
        super(play, fragment, summaryContext);
    }
}
